/**
 * Pollo Veo 3：input 结构单独封装
 * 图生：image 必填，prompt 1-2000，negativePrompt max 2000，length 4|6|8，aspectRatio 16:9|9:16，resolution 720p|1080p，seed，generateAudio
 * 文生：同上，无 image
 */
import { isUrl } from './utils'

var RES_MAP = { '480p': '720p', '480P': '720p', '720p': '720p', '720P': '720p', '1080p': '1080p', '1080P': '1080p' }

function normalizeResolution(v) {
  if (!v) return '720p'
  var key = String(v).trim()
  return RES_MAP[key] || '720p'
}

function normalizeLength(n) {
  var num = parseInt(n, 10)
  if (isNaN(num)) return 8
  if (num <= 4) return 4
  if (num <= 6) return 6
  return 8
}

function normalizeAspectRatio(v) {
  var s = (v || '16:9').replace(/：/g, ':').trim()
  return s === '9:16' ? '9:16' : '16:9'
}

export function buildBody(params) {
  var hasImage = isUrl(params.referenceImage)
  var input = {
    prompt: (params.prompt || '').trim().slice(0, 2000),
    negativePrompt: (params.negativePrompt || '').trim().slice(0, 2000) || undefined,
    length: normalizeLength(params.videoDuration || params.length || 8),
    aspectRatio: normalizeAspectRatio(params.aspectRatio),
    resolution: normalizeResolution(params.videoRes || params.resolution),
    generateAudio: params.generateAudio !== false
  }
  var seed = params.seed != null && params.seed !== '' && params.seed !== -1 ? parseInt(params.seed, 10) : null
  if (seed != null && !isNaN(seed) && seed <= 2147483647) input.seed = seed
  if (hasImage) input.image = params.referenceImage.trim()
  var body = { input: input }
  if (params.webhookUrl && isUrl(params.webhookUrl)) body.webhookUrl = params.webhookUrl
  return body
}
